import Entry2FASetup from './Entry2FASetup';

export default Entry2FASetup;
